import React from 'react';
import PropTypes from 'prop-types';

import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'bento-ordering/base/components/PrimaryCta';

class LocationChangeNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func
  };

  render() {
    return (
      <NotificationModal
        title="Uh oh! That's not an option"
        body="The items already in your cart are unavailable at the location
            you've chosen. You can continue by emptying your cart to start
            a new order."
        onClose={this.props.closeModal}
      >
        <PrimaryCta
          label="Yes, empty my cart"
          handleClick={this.props.handlePrimaryCta}
          fullWidth
        />
      </NotificationModal>
    );
  }
}

export default LocationChangeNotification;
